<template>
  <lf-h1
    v-tooltip="{
      content: $t('RELATIONS.BUSINESS_ENTITY_NOT_AVAILABLE'),
      placement: 'right',
      onShow: () => !id,
    }"
    data-testid="businessNameLink"
    class="overflow-hidden text-ellipsis"
    data-cy="application-name-link"
    :class="!!id ? 'business-name cursor-pointer' : 'cursor-not-allowed'"
    @click="handleClick"
  >
    <span>{{ name }}</span>
    <span
      v-if="!!id || !!name"
      v-tooltip="$t('COMMON.COPY_TO_CLIPBOARD')"
      class="copy-button cursor-pointer rounded-sm px-1 hover:bg-gray-100"
      data-cy="copy-business-name"
      @click.stop="copy"
    >
      <icon-base
        class="text-disabled-medium"
        :icon="IconCopy"
        height="20"
        width="20"
      />
    </span>
  </lf-h1>
</template>

<script setup lang="ts">
import { WORKFLOW_SEGMENT_BUSINESS } from "@/helpers/constants";
import { useClipboardWithMessage } from "@/hooks/clipboard";
import router from "@/router";
import {
  ROUTE_BUSINESS_PROFILE_INFO,
  ROUTE_INDIVIDUAL_PROFILE_PERSONAL_INFO,
} from "@/router/routes";

import IconCopy from "@/components/icons/IconCopy.vue";

const props = withDefaults(
  defineProps<{
    name: string;
    id: string | undefined;
    segment: string;
  }>(),
  { name: "-", segment: WORKFLOW_SEGMENT_BUSINESS }
);

const copyToClipboard = useClipboardWithMessage();

const handleClick = () => {
  if (!props.id) {
    return;
  }

  router.push({
    name:
      props.segment === WORKFLOW_SEGMENT_BUSINESS
        ? ROUTE_BUSINESS_PROFILE_INFO
        : ROUTE_INDIVIDUAL_PROFILE_PERSONAL_INFO,
    params: { id: props.id },
  });
};

const copy = async () => {
  await copyToClipboard(props.name);
};
</script>
<style scoped>
@reference "@/assets/tailwind.css";

.business-name {
  @apply flex items-center space-x-3;
}

.business-name .copy-button {
  @apply invisible;
}

.business-name:hover .copy-button {
  @apply visible;
}
</style>
